import ProductDescription from '@/molecules/ProductDescription'
import Gallery from '@/organisms/Gallery'
import { Media } from '@/templates/Media/Media'
import ProductType from '@/ts/enums/product/ProductType'

import ExperienceInstructions from '../../../../components/molecules/ExperienceInstructions'
import { PresentationProps } from '../../ts'
import FansiVideoCreator from './includes/FansiVideoCreator'
import HowToParticipate from './includes/HowToParticipate'

function Presentation({ creator, product }: PresentationProps) {
  const { nickname } = creator
  const { name, cover, type, description, terms, embedded_link, tags } = product

  return (
    <div className="w-full xl:w-1/2">
      {type === FansiVideo ? (
        <FansiVideoCreator nickname={nickname} name={name} src={cover} />
      ) : (
        <div className="-mx-4 2md:mx-0">
          <Gallery key={Math.random()} product={product} />
        </div>
      )}
      <Media greaterThanOrEqual="xl">
        <ProductDescription
          value={description}
          embedded={embedded_link}
          tags={tags}
        />
        <ExperienceInstructions
          instructions={product.contest_instructions}
          termsHref={terms}
        />
        <HowToParticipate type={type} />
      </Media>
    </div>
  )
}

const { FansiVideo } = ProductType

export default Presentation
